import React from 'react';
import { ListItemBase } from '@annunciate/ui/dist/components/list/ListItemBase';
import { ListItemButtons } from '@annunciate/ui/dist/components/list/ListItemButtons';
export const UnmemoizedListItem = ({ item, isLoading = false, listItemContainerStyle, }) => {
    const isLoadingOrMock = isLoading ||
        !item ||
        item.id === undefined ||
        item.id < 0;
    if (isLoadingOrMock) {
        return (React.createElement(ListItemBase, null));
    }
    switch (item.__typename) {
        case 'Content':
            return (React.createElement(ListItemBase, { item: item, listItemContainerStyle: listItemContainerStyle },
                React.createElement(ListItemButtons, { item: item })));
        case 'Collection':
            return (React.createElement(ListItemBase, { item: item, listItemContainerStyle: listItemContainerStyle },
                React.createElement(ListItemButtons, { item: item, showPlay: false, showDownload: false, showProgress: false })));
        default:
            return React.createElement(React.Fragment, null);
    }
    ;
};
export const ListItem = React.memo(UnmemoizedListItem, ({ item: prevItem }, { item: nextItem }) => {
    const isItemIdIdentical = prevItem?.id === nextItem?.id;
    return isItemIdIdentical;
});
//# sourceMappingURL=ListItem.js.map